<script setup lang="ts">
import LGShopItem from "~/components/partials/LGShopItem.vue";
import LGShopNewsletter from "~/components/partials/LGShopNewsletter.vue";
import { useProductsStore } from '~~/stores/products'
const { t, locale  } = useI18n()

const route = useRoute()
const store = useProductsStore()

const page = computed(() => Number(route.query.page ?? 1))
const perPage = 3

await store.fetchList({ page: page.value, per_page: perPage })

watch([page], async () => {
    await store.fetchList({ page: page.value, per_page: perPage })
})

watch(locale, async () => {
    await store.fetchList({ page: page.value, per_page: perPage, force: true })
})
</script>

<template>
    <section class="py-12 sm:py-24 relative overflow-x-clip">
        <NuxtImg src="/images/home-page/shop-illustration-1.svg" alt="Map" class="hidden lg:block w-[98px] absolute -top-[30px] left-0" />
        <NuxtImg src="/images/home-page/shop-illustration-2.svg" alt="Pin" class="w-[109px] xl:w-[157px] 2xl:w-[227px] absolute -top-4 xl:top-10 -left-[30px] xl:left-[98px]" />
        <NuxtImg src="/images/home-page/shop-illustration-3.svg" alt="Pin" class="hidden lg:block w-[47px] absolute bottom-[200px] right-[10%]" />
        <NuxtImg src="/images/home-page/shop-cloud.svg" alt="Cloud" class="w-[49px] lg:w-[176px] absolute bottom-[30%] -left-4" />
        <NuxtImg src="/images/home-page/shop-cloud.svg" alt="Cloud" class="hidden lg:block w-[109px] absolute top-[40%] right-[100px]" />
        <NuxtImg src="/images/home-page/shop-cloud.svg" alt="Cloud" class="w-[73px] lg:w-[176px] absolute top-[50%] -right-4" />
        <NuxtImg src="/images/home-page/shop-bg-top.svg" alt="Top background" class="w-full h-auto -mb-[1px]" />
        <div class="bg-[#EEEEFA] py-12">
            <UContainer class="lg:max-w-[1000px] flex flex-col gap-12">
                <div class="flex flex-col gap-4.5 items-center lg:max-w-[800px] mx-auto">
                    <h2 class="uppercase text-secondary text-[30px] leading-[38px] sm:text-[36px] sm:leading-[46px]">{{ t("home.shop.title") }}</h2>
                    <p class="text-center text-secondary">{{ t("home.shop.description") }}</p>
                </div>
                <div class="flex flex-col gap-12 z-1">
                    <LGShopItem v-for="p in store.items" :key="p.product_id" :product="p" />
                </div>
                <LGShopNewsletter/>
            </UContainer>
        </div>
        <NuxtImg src="/images/home-page/shop-bg-bottom.svg" alt="Bottom background" class="w-full h-auto -mt-[1px]" />
    </section>
</template>

<style scoped>

</style>
